import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export type AccountTabId =
	| "overview"
	| "details"
	| "financials"
	| "financials-prototype"
	| "wip"
	| "indemnity"
	| "bonds";
export type AccountDetailsSubsectionId = "companies" | "individuals" | "history";
export type AccountOverviewSubsectionId = "attachments";
export type AccountNavigation =
	| {
			tabId: "details";
			subsectionId?: AccountDetailsSubsectionId;
	  }
	| {
			tabId: "overview";
			subsectionId?: AccountOverviewSubsectionId;
	  }
	| {
			tabId: Exclude<AccountTabId, "details" | "overview">;
			subsectionId?: undefined;
	  };

export function useAccountTabsNavigation() {
	const navigate = useNavigate();
	const { pathname, search } = useLocation();

	return useCallback(
		(config: AccountNavigation, options: { replace: boolean } = { replace: false }) => {
			const next = new URLSearchParams(search);
			next.set("t", config.tabId);
			if (config.subsectionId) next.set("st", config.subsectionId);
			else next.delete("st");
			const query = next.toString();
			navigate({ pathname, search: query ? `?${query}` : "" }, options);
		},
		[navigate, pathname, search],
	);
}
